import React, { useState, useMemo } from "react";
import "./adjustments.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchSAAdjustment, fetchSALedger } from "../../redux/actions/actionStandaloneAdj";
import AdjustmentFilter from "./components/AdjustmentFilter";
import AdjustmentHeader from "./components/AdjustmentHeader";
import AdjustmentsTable from "./components/AdjustmentsTable";
import swal from "sweetalert";
import { applyAdjFilter } from "./adjustmentHelperFunction";

import { motion } from "framer-motion";
import Sidebar from "../../myfin_v2/elements/Sidebar"
import commoncss from "../../myfin_v2/css/common.module.css"
import bookclosuretablecss from "../../myfin_v2/css/bookclosuretable.module.css";


const Adjustments = () => {
    const dispatch = useDispatch();
    const project_id = localStorage.getItem("project_id");
    const tb_id = localStorage.getItem("tb_id");

    const filterData = useSelector((initialState) => initialState.reducer.filter);
    const {
        loading,
        // isSuccess,
        adjustmentData,
        copyAdjData,
        projectData,
        ledgerIsSuccess,
        ledgerData
    } = useSelector((initialState) => initialState.ADJStandaloneReducer);

    const [filterShow, setFilterShow] = useState(false);
    const [showCreate, setShowCreate] = useState(false);
    const [editOn, setEditOn] = useState(false);
    const [state, setstate] = useState([]);

    useMemo(() => {
        setstate([]);
        // if (!isSuccess) {
        dispatch(fetchSAAdjustment(project_id, tb_id));
        // }
        if (!ledgerIsSuccess) {
            dispatch(fetchSALedger(project_id, tb_id));
        }
    }, [ledgerIsSuccess]);

    const handleOptions = () => {
        if (editOn) {
            swal(
                "Warning",
                "Please Save the adjustment to create new adjustments",
                "warning"
            );
            return;
        }
        setShowCreate(true);
    }

    const handleApplyFilter = () => {
        dispatch(applyAdjFilter(copyAdjData, filterData, "SA_ADJ_FILTER"));
    }

    return (
        <>
            <div className={commoncss.pageLayout}>
                <Sidebar />
                <div className={`d-flex ${commoncss.pageContent}`}>
                    <motion.div
                        initial={{ x: -100, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: 0, opacity: 0 }}
                        transition={{ duration: 0.5, ease: "easeInOut" }} className={commoncss.w100} style={{ overflowY: "auto" }} >

                        <AdjustmentHeader
                            adjustmentData={adjustmentData}
                            setFilterShow={setFilterShow}
                            filterShow={filterShow}
                            handleOptions={handleOptions}
                        />


                        <AdjustmentsTable
                            loading={loading}
                            adjustmentData={adjustmentData}
                            ledgerData={ledgerData}
                            projectData={projectData}
                            showCreate={showCreate}
                            setShowCreate={setShowCreate}
                            setEditOn={setEditOn}
                            editOn={editOn}
                        />

                    </motion.div>

                    <AdjustmentFilter
                        actionFrom={"adjustment"}
                        show={filterShow}
                        handleApplyFilter={handleApplyFilter}
                        setFilterShow={setFilterShow}
                        setObject={() => { }}
                        state={state}
                        setstate={setstate}
                    />
                </div>
            </div >
        </>
    );
};

export default Adjustments;
